import React from 'react'
import { Card, Col, Row } from 'antd';
import Logo from '../assets/logo.png'
import IphoneOne from '../assets/ios-1.jpeg'
import AndroidOne from '../assets/android-1.jpeg'
import IphoneTwo from '../assets/ios-2.jpeg'
import AndroidTwo from '../assets/android-2.jpeg'
import IphoneThree from '../assets/ios-3.jpeg'
import AndroidThree from '../assets/android-3.jpeg'
import AppStore from '../assets/app-store.png'
import GooglePlay from '../assets/google-play.png'

function Home() {
  return (
    <div>
      <div style={{ display:'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundImage: `linear-gradient(180deg, #ffe25a, #ffa851)`}}>
          <img src={Logo} style={{ width: 200, height: 200 }} alt="logo"/>
          <h1 style={{ fontWeight: 'bold' }}>Country Cup</h1>
      </div>
      <Row style={{ justifyContent: 'space-between', backgroundImage: `linear-gradient(180deg, #56ccf2, #2f80ec)`}}>
        <Col span={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <h1 style={{ color: 'white', textAlign: 'center', fontWeight: 'bold'}}>All Country cup qualifier teams</h1>
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
          <img src={IphoneOne} style={{ height: 500 }} alt="logo"/>
          <img src={AndroidOne} style={{ height: 500 }} alt="logo"/>
        </Col>
      </Row>
      <Row style={{ justifyContent: 'space-between', backgroundImage: `linear-gradient(180deg, #ffe25a, #ffa851)`}}>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
          <img src={IphoneTwo} style={{ height: 500 }} alt="logo"/>
          <img src={AndroidTwo} style={{ height: 500 }} alt="logo"/>
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <h1 style={{ color: 'black', textAlign: 'center', fontWeight: 'bold'}}>Play Game and get points!</h1>
        </Col>
      </Row>
      <Row style={{ justifyContent: 'space-between', backgroundImage: `linear-gradient(180deg, #56ccf2, #2f80ec)`}}>
        <Col span={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          <h1 style={{ color: 'white', textAlign: 'center', fontWeight: 'bold'}}>Available on IOS and Android</h1>
          <h1 style={{ color: 'white', textAlign: 'center', fontWeight: 'bold'}}>Download now!</h1>
          <Row>
            <Col>
              <img src={AppStore} style={{ width: 150 }} alt="logo"/>
            </Col>
            <Col>
              <img src={GooglePlay} style={{ marginLeft: 20, width: 180 }} alt="logo"/>
            </Col>
          </Row>
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
          <img src={IphoneThree} style={{ height: 500 }} alt="logo"/>
          <img src={AndroidThree} style={{ height: 500 }} alt="logo"/>
        </Col>
      </Row>
    </div>
  );
}

export { Home }